module.exports = __webpack_public_path__ + "static/media/logo_main_light.a4c7df13.png";